/* tt-cadeau.js (r16cadeau): (1) order deadline line, (2) gift message field.
   Both are plain DOM work, no network. The deadline is computed from the VISITOR's date, because Shopify's page cache makes Liquid `now` stale.
   Lines stay `hidden` until the sum succeeded, so nothing shows without JS and nothing shows a wrong date. */
(function () {
  'use strict';
  if (window.__ttCadeau) return;
  window.__ttCadeau = true;

  var DAYS = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  var MONTHS = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
  var WINDOW_DAYS = 60;

  // Working day: Monday to Friday, except 1 January, 25 December and 26 December.
  function isWork(d) {
    var w = d.getDay(), m = d.getMonth() + 1, n = d.getDate();
    if (w === 0 || w === 6) return false;
    if (m === 1 && n === 1) return false;
    if (m === 12 && (n === 25 || n === 26)) return false;
    return true;
  }
  function dayOnly(y, m, d) { return new Date(y, m, d); }
  function minusWork(date, n) {
    var d = dayOnly(date.getFullYear(), date.getMonth(), date.getDate());
    while (n > 0) { d.setDate(d.getDate() - 1); if (isWork(d)) n--; }
    return d;
  }
  // Upper bound of "5 werkdagen" (the lead-time sentence is the one source): the largest number before "werkdagen".
  // 15-10 Vincent: the sentence says "meestal binnen 5 werkdagen verzonden" (small orders), bigger orders take longer. The order deadline keeps the cautious 10 working days (lead 5 + 5), so Sinterklaas stays 19-11 and Kerst 8-12.
  var LARGE_ORDER_EXTRA = 5;
  function leadMax(text) {
    var m = /(\d+(?:\s*(?:tot|t\/m|-)\s*\d+)?)\s*werkdagen/i.exec(text || '');
    if (!m) return 0;
    var nums = m[1].match(/\d+/g) || [], max = 0;
    for (var i = 0; i < nums.length; i++) max = Math.max(max, parseInt(nums[i], 10));
    return max;
  }
  // "Sinterklaas|12-05;Kerst|12-24" -> [{name, month (0-based), day}]
  function parseEvents(raw) {
    var out = [];
    String(raw || '').split(/[;\n]/).forEach(function (part) {
      var p = part.split('|'), m = /^\s*(\d{1,2})-(\d{1,2})\s*$/.exec(p[1] || '');
      if (p[0].trim() && m) out.push({ name: p[0].trim(), month: parseInt(m[1], 10) - 1, day: parseInt(m[2], 10) });
    });
    return out;
  }

  function next(now, events, lead, ship) {
    var today = dayOnly(now.getFullYear(), now.getMonth(), now.getDate()), best = null;
    for (var y = today.getFullYear(); y <= today.getFullYear() + 1; y++) {
      events.forEach(function (ev) {
        var date = dayOnly(y, ev.month, ev.day);
        if (date < today || (date - today) / 86400000 > WINDOW_DAYS) return;
        var deadline = minusWork(date, lead + ship);
        if (deadline < today) return; // past: no false promise
        if (!best || date < best.date) best = { name: ev.name, date: date, deadline: deadline };
      });
    }
    return best;
  }

  function deadlines() {
    var els = document.querySelectorAll('[data-tt-deadline]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], txt = el.querySelector('[data-tt-deadline-text]');
      el.hidden = true;
      if (!txt) continue;
      var lead = leadMax(el.getAttribute('data-lead')) + LARGE_ORDER_EXTRA, ship = parseInt(el.getAttribute('data-ship-days'), 10), events = parseEvents(el.getAttribute('data-events'));
      if (!lead || !(ship >= 0) || !events.length) { if (window.console) console.warn('tt-deadline: lead ' + lead + ', ship ' + ship + ', events ' + events.length + ': no line shown'); continue; }
      var hit = next(new Date(), events, lead, ship);
      if (!hit) continue;
      var d = hit.deadline;
      // r19pdp: the full sentence stays in the text; on a phone the CSS hides the .tt-dl-lang parts and shows the .tt-dl-kort parts (one line: 'Sinterklaas: uiterlijk do 19 nov')
      // only inside the PDP info column (tt-pdp.css loads there); the cart and other pages get ONE text node with the full sentence
      var d_full = 'Op tijd voor ' + hit.name + ': bestel uiterlijk ' + DAYS[d.getDay()] + ' ' + d.getDate() + '\u00a0' + MONTHS[d.getMonth()]; // kritdev17 E10: day and month never part (1440: "november" alone on line 2)
      if (!el.closest('.product__info-container')) { txt.textContent = d_full; el.hidden = false; continue; }
      txt.textContent = '';
      [['tt-dl-lang', 'Op tijd voor '], ['', hit.name + ': '], ['tt-dl-lang', 'bestel '], ['', 'uiterlijk '], ['tt-dl-lang', DAYS[d.getDay()]], ['tt-dl-kort', DAYS[d.getDay()].slice(0, 2)], ['', ' ' + d.getDate() + '\u00a0'], ['tt-dl-lang', MONTHS[d.getMonth()]], ['tt-dl-kort', MONTHS[d.getMonth()].slice(0, 3)]].forEach(function (p) {
        if (!p[0]) { txt.appendChild(document.createTextNode(p[1])); return; }
        var sp = document.createElement('span'); sp.className = p[0]; if (p[0] === 'tt-dl-kort') sp.setAttribute('data-k', p[1]); else sp.textContent = p[1]; txt.appendChild(sp); // the short form lives in data-k (CSS ::after), so textContent is the full sentence only
      });
      el.hidden = false;
    }
  }

  function gift(root) {
    var ta = root.querySelector('[data-tt-cadeau-in]'), cnt = root.querySelector('[data-tt-cadeau-n]');
    if (!ta) return;
    var max = parseInt(ta.getAttribute('maxlength'), 10) || 150;
    function sync() {
      if (ta.value.length > max) ta.value = ta.value.slice(0, max);
      if (cnt) cnt.textContent = ta.value.length;
      // Empty or only spaces: no property at all (a nameless field is not part of the FormData).
      if (ta.value.trim()) ta.setAttribute('name', 'properties[Cadeaubericht]'); else ta.removeAttribute('name');
      root.classList.toggle('tt-cadeau--vol', ta.value.length >= max);
    }
    ta.addEventListener('input', sync);
    sync();
  }

  function init() {
    deadlines();
    var roots = document.querySelectorAll('[data-tt-cadeau]');
    for (var i = 0; i < roots.length; i++) gift(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
